module.exports = __webpack_public_path__ + "img/homePad_logo_ico.c7e329ff.svg";